export default __webpack_public_path__ + "static/media/samsung-you-saved.d24658d3.png";